// extracted by mini-css-extract-plugin
export default {"field_Descr":"UnitCreatorModal_field_Descr__hFkEo","modalCreate":"UnitCreatorModal_modalCreate__OQJhn"};